import { HTMLMotionProps } from 'motion/react'

export function simpleRise(): HTMLMotionProps<'div'> {
	return {
		initial: {
			opacity: 0,
			translateY: 6,
		},
		animate: {
			opacity: 1,
			translateY: 0,
		},
		exit: {
			opacity: 0,
			translateY: -9,
		},
	}
}
